// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import actionCreators from "@modules/service/actionCreator";
import type {
  StandardQuestion,
  StandardQuestionContent,
} from "@modules/service/reducer/standard-questions/types";
import * as serviceSelectors from "@modules/service/selectors";
import { Button, SchemaForm } from "@components";
import { uiSchema } from "./uiSchema";
import type { StepProps } from "@components";
import type { State } from "@store/reducers";

type PropsFromState = $Exact<{
  draft: ?StandardQuestionContent,
  schema: ?Object,
}>;

type PropsFromDispatch = $Exact<{
  onUpdateDraft: typeof actionCreators.UpdateStandardQuestionDraft,
}>;

type Props = $Exact<{
  ...StepProps,
  ...PropsFromLocalize,
  ...PropsFromState,
  ...PropsFromDispatch,
}>;

export class Step1MainDetails extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  handleQuestionTypeNext = () => {
    if (this.formRef) {
      this.formRef.current.submit();
    }
  };

  handleSubmit = (formData: Object) => {
    if (formData) {
      const updatedDraft = { ...this.props.draft, ...formData };
      this.props.onUpdateDraft(updatedDraft);
      if (this.props.handleSubmit) {
        this.props.handleSubmit(updatedDraft, true);
      }
    }
  };

  get data(): Object {
    // use "undefined" as an initial value to a property, which works best with the schema
    // using "null" as an initial value, the selector component will select automatically the fist option
    return {
      advisorType: "ALL",
      isActive: (this.props.draft || {}).isActive,
      standardQuestion: (this.props.draft || {}).standardQuestion || undefined,
    };
  }

  onChange = (formData: Object) => {
    const updatedDraft = { ...this.props.draft, ...formData };
    this.props.onUpdateDraft(updatedDraft);
  };

  render() {
    if (!this.props.editable) {
      return null;
    }

    return (
      <React.Fragment>
        <div className="w-100 d-flex justify-content-center">
          <div className="col-sm-8">
            <SchemaForm
              ref={this.formRef}
              className="w-100"
              formData={this.data}
              schema={this.props.schema || {}}
              uiSchema={uiSchema(this.props.t)}
              onSubmit={this.handleSubmit}
              externalSubmit
              onChange={this.onChange}
              longLabels
            >
              <div className="d-flex justify-content-center" />
            </SchemaForm>
          </div>
        </div>
        <div className="w-100 d-flex justify-content-end mt-5 mb-3">
          <Button materialIcon="fast_forward" onClick={this.handleQuestionTypeNext}>
            {this.props.t("NEXT")}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: State, ownProps: Object): PropsFromState => {
  return {
    draft: serviceSelectors.getStandardQuestionDraft(state),
    schema: serviceSelectors.getStandardQuestionRevisionSchema(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  onUpdateDraft: actionCreators.UpdateStandardQuestionDraft,
};

export default compose(localize(), connect(mapStateToProps, mapDispatchToProps))(Step1MainDetails);
